import styled, { css } from "styled-components";
import { lighten, readableColor } from 'polished';
import { Col, Row } from "@intech/web-ui";
import { device } from "../../../device";

export const WrapRow = styled(Row)`
  flex-wrap: wrap;
  align-items: baseline;
  width: 100%;
`;

export const AutoColumn = styled(Col)`
  width: 100%;
  @media ${device.tablet} {
    flex: 1 0 30%;
    max-width: 30%%;
  }
  @media not ${device.tablet} {
    flex: 1 0 100%;
    max-width: 100%%;
  }
`;